import { semanticTokenVars } from '@tundr/ds-tokens';
import { style, styleVariants } from '@vanilla-extract/css';
import { SlideoverVariant } from './Slideover.types';

export const slideoverBackgroundClass = style({
  transform: 'translateZ(0)',
  position: 'fixed',
  inset: 0,
  zIndex: 940,
  backgroundColor: semanticTokenVars.surface.overlay.backdrop,
});

export const slideoverContainerClass = style({
  transform: 'translateZ(0)',
  outline: 'none !important',
  display: 'flex',
  flexDirection: 'column',
  position: 'fixed',
  top: 0,
  right: 0,
  height: '100vh',
  zIndex: 941,
  backgroundColor: semanticTokenVars.surface.background.neutral.default.base,
  border: 'none',
  overflow: 'hidden',
});

export const slideoverContainerVariantClass = styleVariants({
  [SlideoverVariant.SM]: { width: '33%', minWidth: 480 },
  [SlideoverVariant.MD]: { width: '50%', minWidth: 720 },
  [SlideoverVariant.LG]: { width: '70%', minWidth: 1040 },
});
